<script>
import { headersEmployees } from "@/assets/static.js";
import CustomListMenu from "@/components/custom/CustomListMenu.vue";
import { fourOptions } from "@/assets/static.js";
import { mapGetters, mapActions, mapMutations } from "vuex";
import SortButton from "@/components/custom/SortButton.vue";
export default {
  name: "ُEmployeesTable",
  props: {
    dataFilter: Array,
    isFilter: Boolean,
  },
  data: () => ({
    mobileBreakpoint: 600,
    length: 12,
    headers: headersEmployees,
    optionsList: fourOptions,
    page: 1,
    ascending: true,
    sortBy: "name",
    // ...................
    selectedRow: null,
    // ...................
  }),

  methods: {
    actionMenu(data) {
      this.$emit("actionMenu", data);
    },

    ...mapMutations(["SET_LOADING"]),
    ...mapActions(["getEmployees", "set_page"]),
    getEmployeesFunc() {
      this.set_page(this.page);
      this.getEmployees();
    },
    //.....................
    selectRow(item) {
      this.selectedRow = item.id;
    },
    isSelected(item) {
      return item.id === this.selectedRow;
    },
    selectRowEvent(item) {
      this.selectedRow = item;
      this.isSelected(item);
    },
    sortTable(column) {
      if (column === this.sortBy) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    //.....................
    sortedList(payload) {
      this.employees = payload.list;
      this.ascending = payload.ascending;
    },
  },
  computed: {
    translatedHeaders() {
      return this.headers.map((header) => ({
        ...header,
        text: this.$t(header.text),
      }));
    },
    ...mapGetters(["employeesListGet", "paginationGet"]),
    employees() {
      return this.employeesListGet;
    },
    // employeesList() {
    //   return this.filterNoDataGet ? this.filterArrayGet : this.employeesListGet;
    // },
  },
  components: {
    CustomListMenu,
    SortButton,
  },
  mounted() {
    this.set_page(this.page);
    this.getEmployees({ isModal: false });
  },
};
</script>
<style scoped>
@import "@/assets/css/tableStyle.css";
@import "@/assets/css/style.css";
th {
  text-align: center !important;
}

/* ....................... */
.highlighted-row {
  background-color: #eeeeee;
}
/* ....................... */

/* each row block css in mobile*/
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-table-row {
  margin: 10px;
  border: 1px solid #ededed;
  display: block;
}

/* each cell border in mobile */
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  border-bottom: 1px solid #ededed;
}
@media only screen and (max-width: 600px) {
  .v-data-table td {
    font-size: 12px;
  }
}
</style>
<template>
  <v-sheet
    class="transparent d-flex align-center justify-space-between flex-column table_cont"
    width="100%"
    height="75vh"
  >
    <v-sheet class="transparent" width="100%">
      <SortButton
        :ascending="ascending"
        :list="employees"
        :attr="sortBy"
        @sort="sortedList"
      />
      <v-data-table
        :headers="translatedHeaders"
        :items="!isFilter ? employeesListGet : dataFilter"
        :loading="!employeesListGet.length && this.paginationGet.total != 0"
        :no-data-text="$t('noData')"
        :total-items="this.paginationGet.total"
        :server-items-length="this.paginationGet.itemsPerPage"
        :items-per-page.sync="this.paginationGet.itemsPerPage"
        hide-default-footer
        item-key="id"
        @update:page="getEmployeesFunc()"
        class="elevation-0 rounded-0"
        @click:sort="sortTable"
      >
        <template #item="{ item }">
          <!-- ........................ -->
          <tr
            :class="{ 'highlighted-row': isSelected(item) }"
            @click="selectRow(item)"
          >
            <!-- ........................ -->

            <td class="text-">
              {{ item.name + " " + item.l_name }}
            </td>
            <td>
              {{ item.job_description }}
            </td>
            <td>
              {{ item.department }}
            </td>
            <td>
              {{ item.birthday }}
            </td>
            <td>
              {{ item.job_date }}
            </td>
            <td class="text-center">
              <!-- .......................... -->
              <CustomListMenu
                :items="optionsList"
                :id="item.id"
                @actionMenu="actionMenu"
                @selectRow="selectRowEvent"
              />
              <!-- .......................... -->
            </td>
          </tr>
        </template>
        <!-- <template v-slot:[`item`]="{ item }">
        <td>
          <CustomListMenu
            :items="optionsList"
            :id="item.text"
            @actionMenu="actionMenu"
          />
        </td>
      </template> -->
      </v-data-table>
    </v-sheet>

    <!-- Pagination -->

    <v-sheet class="transparent">
      <v-row class="text-center px-4 align-center" wrap>
        <v-col cols="12" md="12">
          <v-pagination
            rounded="circle"
            v-model="page"
            color="orange"
            :length="this.paginationGet.lastPage"
          >
          </v-pagination>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- Pagination End -->
  </v-sheet>
</template>
